import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HouseRegionMapComponent} from './house-region-map.component';

@NgModule({
  declarations: [HouseRegionMapComponent],
  imports: [CommonModule],
  exports: [HouseRegionMapComponent]
})
export class HouseRegionMapModule {}
